import React from "react";
import { Card, CardContent, Typography, Box } from "@mui/material";

const AuthCard = ({ title, children }) => {
  return (
    <Card
      sx={{
        width: "100%",
        maxWidth: 400,
        padding: 3,
        background: "rgba(255, 255, 255, 0.1)",
        backdropFilter: "blur(10px)",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
        color: "#ffffff",
      }}
    >
      <CardContent>
        <Typography variant="h5" fontWeight="bold" textAlign="center" mb={2}>
          {title}
        </Typography>
        <Box>{children}</Box>
      </CardContent>
    </Card>
  );
};

export default AuthCard;
